import styled from 'styled-components';

export default styled.div`
  background: rgba(247, 248, 253, 1);
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: auto;
  padding-top: 5rem;
  text-align: center;
  ${ props => props.thisStyles }
`;
